import { Dimensions, StyleSheet } from "react-native"
import { baseColors } from "@Constants/baseStyles"
const { height } = Dimensions.get("screen")

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignContent: "space-between",
        alignItems: "center",
        //height: height / 6,
        paddingHorizontal: 20,
        paddingVertical: 15,
        backgroundColor: baseColors.orange.primary
    },
    overlay: {
        // marginTop: -15,
        width: "100%",
        borderRadius: 15,
        backgroundColor: "white"
    },
    dotsContainer: {
        height: 40,
        flexDirection: "row",
        width: "100%",
        padding: 20,
        alignItems: "center",
        justifyContent: "center",
        alignContent: "center"
    },
    dot: { marginHorizontal: 5, borderRadius: 5, height: 10, width: 10 },
    col: {
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-between",
        paddingHorizontal: 20
    }
})

export default styles
